let epoch = 0;
const listeners = new Set();

export function getFollowingFeedEpoch() {
  return epoch;
}

/** Follow/unfollow changes server truth; Following feed reloads instead of deleting cards locally. */
export function bumpFollowingFeedEpoch() {
  epoch += 1;
  listeners.forEach((listener) => listener(epoch));
}

export function subscribeFollowingFeedEpoch(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
